import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=12641e50"
import script from "./Subscription.vue?vue&type=script&lang=js"
export * from "./Subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports